import jwt_decode from 'jwt-decode';

const getClienteIntegracao = () => {
    let usr = localStorage.getItem("user")
    let parsedUsr = usr ? JSON.parse(usr) : null
    let decodedToken = parsedUsr ? (jwt_decode(parsedUsr.token) as any) : null;
    return decodedToken.isclienteintegracao === "True";
}

export default getClienteIntegracao